import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";

const ImportData = () => {
  const language = useSelector((state) => state.language || "en");
  const translation = useSelector((state) => state.translation || {});

  const [uploadResult, setUploadResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const onDrop = async (acceptedFiles) => {
    if (!acceptedFiles[0]) {
      alert("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", acceptedFiles[0]);
    setLoading(true);
    try {
      const token = "bearer " + localStorage.getItem("accessToken");
      console.log("token",token);
      console.log("formData",formData);
      const result = "";
      setUploadResult(result);
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Error uploading file.");
    } finally {
      setLoading(false);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".csv",
  });

  const downloadTemplate = () => {
    const templateData = [
      "Product Name*,Store*,Supplier,Category*,Sub Category*,Product Type,Description (Maximum 1000 Characters),Image (URL),Variants,Price*,Discount Type,Discount Value,Status*,Weight (kg),Quantity*\n",
      ",,,,,Normal,,,\"Size: L\nColor: Blue\",,Percentage,,Active,,,\n"
    ].join("");

    const blob = new Blob([templateData], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "product_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">{translation[language]?.["data_import"] || "Data Import"}</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    {translation[language]?.["import_product_data"] || "Import Product Data"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">
                    {translation[language]?.["product_file_upload"] || "Product File Upload"}
                  </h5>
                </div>
                <div className="card-body">
                  <button className="btn btn-primary mb-4" onClick={downloadTemplate}>
                    Download Template
                  </button>
                  <div
                    className="custom-file-container"
                    data-upload-id="myFirstImage"
                  >
                    <div
                      {...getRootProps()}
                      style={{
                        border: "2px dashed #13B3C1",
                        padding: "20px",
                        textAlign: "center",
                        cursor: "pointer",
                        height: "200px",
                      }}
                    >
                      {loading && (
                        <div
                          className="loader-content"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 2,
                          }}
                        >
                          <div id="global-loader">
                            <div className="whirly-loader"></div>
                          </div>
                        </div>
                      )}
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here ...</p>
                      ) : (
                        <p>Drag n drop a file here, or click to select one</p>
                      )}
                    </div>
                  </div>
                  {uploadResult && uploadResult.invalidRecords && (
                    <table className="table mt-4">
                      <thead>
                        <tr>
                          <th>Store</th>
                          <th>Date</th>
                          <th>Hour</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {renderInvalidRecords(uploadResult.invalidRecords)} */}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportData;